import methods from '@/services/methods'

export default {
  accountSettingsDetails () {
    return methods.sendGet('account', null, {unprivilege: 'Settings'})
  },
  updateGst (payload) {
    return methods.sendPost('account/gst', payload)
  },
  updateAddress (payload) {
    return methods.sendPost('account/address', payload)
  },
  updateLowBalance (payload) {
    return methods.sendPost('account/low_balance', payload)
  },
  enable2FA () {
    return methods.sendPost(`account/enable_two_factor`)
  },
  disable2FA () {
    return methods.sendPost(`account/disable_two_factor`)
  }
}
